/**
 * Charts
 * @requires https://www.chartjs.org/
 */

(function () {
  function initCharts() {
    const charts = document.querySelectorAll('[data-chart]')
    if (charts.length === 0) return

    charts.forEach((chartElement) => {
      const {chart: chartData} = chartElement.dataset
      const options = JSON.parse(chartData || '{}')
      // Assumes "Chart" is globally available
      if (typeof Chart !== 'undefined') {
        new Chart(chartElement, options)
      }
    })
  }

  document.addEventListener('turbo:load', initCharts)
})()
